import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
  MatTreeNestedDataSource,
} from '@angular/material/tree';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { FinancialGoalService } from 'src/app/modules/financial-goal/services/financial-goal.service';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { WithdrawOpportunityPopupComponent } from 'src/app/modules/users/withdraw-opportunity-popup/withdraw-opportunity-popup.component';
import { AuthenticationService } from '../../services/authentication.service';
import { LoadingService } from '../../services/loader.service';
import { transition, trigger, useAnimation } from '@angular/animations';
import { SidebarOpenAnimation, SidebarCloseAnimation } from './animations';
import { TooltipPosition } from '@angular/material/tooltip';
import { ResumeOrStartPopupComponent } from '../layouts/resume-or-start-popup/resume-or-start-popup.component';
const animationParams = {
  menuWidth: '350px',
  animationStyle: '500ms ease',
};
interface applicationNode {
  name: string;
  oppID: string;
  a?: string;
  b?: string;
  c?: string;
  d?: string;
  e?: string;
  f?: string;
  g?: string;
  h?: string;
  i?: string;
  j?: string;

  children?: applicationNode[];
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}
enum opportunityStage {
  'ece3b3ec-e98a-4d95-8ce0-eff28d771b26',
  '2d8c0501-6d5d-4f7e-a0c0-e9afe7c52164',
  '2eda2878-affb-4fb3-ae3a-7d86a737a786',
  'ba486328-0485-4273-b4ab-9a9faaa22423',
  'f041dfe1-8e90-430c-9eb8-85ced7da8386',
  '9ffd96ef-b806-4871-bf37-1a77a7edafc0',
  '4cbe1585-4102-4ea1-bf17-a9e5328020d5',
  '5da0f5ec-d070-48cf-946e-b4977631459a',
  '16a09f15-0fef-4315-853b-83d47be3b241',
}
enum superannuationOpportunityStage {
  'a11f4588-28ec-8a7a-86f4-1d06dd4200cb',
  '2ee1ba75-0b75-40c9-9a75-9106f4182f16',
  'bf20f70a-8f44-4ef6-8e28-2de5fe2921c9',
  'df4ce430-ccee-4a24-b922-da984b27adb9',
  'b43ca487-1cca-40a5-8fbd-de322210386f',
  '25e0e995-b9bd-4269-a68d-87df4a17b455',
  '49e1509f-5970-42bd-85ae-0763915eae08',
  'b50c99a7-a462-4b92-b960-b3a28f3de9a8',
  '86a29103-435a-4d13-bfcf-7509cdedd7d7',
}

enum managedInvestmentOpportunityStage {
  '7a2e74cf-784e-4a40-a6d4-52a78cfaddb1',
  '56b2b8c3-810b-4538-b3da-dcabd8b82a27',
  '245e5731-0211-428d-aaf0-96bb04702f7d',
  'bf12435e-14a5-49b1-94ad-1587b1f50f66',
  'ad8aa40b-c284-4eb7-a0e4-644035d7cd6a',
  '5ec99075-3775-4a62-9984-4a9c2f64cc9c',
  '8f49837e-20bd-4909-a1bc-f7f55c0f0bb2',
  'a6f4e59d-8c3d-4b40-bace-b93e1ebed4a2',
  '18101044-3c51-45f5-8b2b-4bc8405047c8',
}
enum generalInsuranceOpportunityStage {
  '3d2d49c7-17f7-4e61-be92-7aec9d824fe9',
  '1e95aa1f-ce10-4a49-869f-73a17d4291cd',
  'daa80418-f805-49d1-a5ed-24d6b515529c',
  '7297956a-c73c-4971-ae62-e32114e29182',
  '06ddfd5e-8e72-47f5-b507-51534d4b62b3',
  '81c266c2-9e8b-4dba-9e1f-93b7b92ef672',
}

enum healthInsuranceOpportunityStage {
  'dd7d0688-38bc-484f-b3b6-00d974c00b3d',
  'a7e8150f-e667-4e32-a250-9f0e2aa4f1e9',
  '7279b36d-eb5b-42d8-a413-00b20233209b',
  '59b5f987-c91a-4f54-9171-7c1084a7f1cd',
  '95c0ac62-c756-489a-a5ba-fd80097b3895',
  'cb3d67b2-d699-47bf-945d-4828c8be0e3e',
}
enum estatePlanningOpportunityStage {
  '860c244b-9214-48f4-942e-267926726fdb',
  'd408967b-797a-48f2-9200-4233ff61d00d',
  'c8d01d17-01f1-4e6e-9db9-545ffed1f890',
  '143a267d-bfe0-48bb-9d5c-109c2f6c17b1',
  'b4878a2f-d020-4b70-82a6-25b3fecc6f00',
  'dd752a5e-b234-4241-912f-a8937dab14ee',
}
enum financialPlanningOpportunityStage {
  '97f16148-4f74-4ead-887d-c3546a6e8cf9',
  '05de9ac0-c6cb-458d-8ce9-7b15f27f20d3',
  '47153fb5-92e1-4256-97c9-19e17695e210',
  '761cd62f-cb3d-462c-86e9-d82be5aab55d',
  '274a2637-1ce8-414e-a870-1d581b726c89',
  '2533fab7-2fb0-4855-8a10-d55ece667f9b',
  '2d159854-8941-45c4-87df-9cfe05a27bee',
  'ed46d589-c988-4fff-86da-a7cee673f375',
  'ecd6e91a-2ed8-4222-b45c-b41ca49685b6',
}
// enum stages {
//   'Client Registration',
//   'Confirm Loan Needs',
//   'Confirm Family Details',
//   'Gather Documents',
//   'Product Recommendation',
//   'Submission To Lender',
//   'Loan Approval',
//   'Loan',
//   'Settlement Booked',
//   'Settlement Complete',
// }

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
  animations: [
    trigger('sideMenu', [
      transition(':enter', [
        useAnimation(SidebarOpenAnimation, {
          params: {
            ...animationParams,
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(SidebarCloseAnimation, {
          params: {
            ...animationParams,
          },
        }),
      ]),
    ]),
  ],
})
export class SideBarComponent implements OnInit, OnDestroy {
  // // // completedApplication = [];
  openApplication = [];
  userData;
  userFirstName: string;
  userLastName: string;
  image: any = '../../../../../assets/images/avatar.jpg';
  imageBlob;
  username: string;
  // currentOpportunity: string; // = 'e26bc19f-bcee-eb11-94ef-00224814e86f';
  token;
  targetDiv: HTMLDivElement;
  @ViewChild('targetDiv') targetRefrence: ElementRef;
  public toggle = true;

  positionOptions: TooltipPosition = 'right';

  // treeControl = new FlatTreeControl<ExampleFlatNode>(
  //   (node) => node.level,
  //   (node) => node.expandable
  // );
  // private _transformer = (node: applicationNode, level: number) => {
  //   return {
  //     expandable: !!node.children && node.children.length > 0,
  //     name: node.name,
  //     oppID: node.oppID,
  //     a: node.a,
  //     b: node.b,
  //     c: node.c,
  //     d: node.d,
  //     e: node.e,
  //     f: node.f,
  //     g: node.g,
  //     h: node.h,
  //     i: node.i,
  //     j: node.j,

  //     level: level,
  //   };
  // };
  // treeFlattener = new MatTreeFlattener(
  //   this._transformer,
  //   (node) => node.level,
  //   (node) => node.expandable,
  //   (node) => node.children
  // );
  opportunitySubscription: Subscription;

  sideBarSubscription: Subscription;
  // dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  showData = false;
  // Active sub nav
  activeNav = '';
  debtstageActive = [];
  constructor(
    private financeService: FinancialGoalService,
    private userService: UsersService,
    public auth: AuthenticationService,
    private loadingService: LoadingService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.token = this.auth.getUserAccessToken();
    //  this.dataSource1.data = Open_DATA;
    // this.dataSource.data = TREE_DATA;
    // this.userData = this.auth.getDecodedUserAccessToken();
    // this.username = `${this.userData.contactDetails[0].firstname} ${this.userData.contactDetails[0].lastname}`;
    // console.log(this.username);
    // this.userFirstName = this.userData.contactDetails[0].firstname.charAt(0);
    // this.userLastName = this.userData.contactDetails[0].lastname.charAt(0);
    this.imageBlob = this.auth.getLoginImage();
    if (this.imageBlob) {
      const objectURL = 'data:image/jpeg;base64,' + this.imageBlob;
      this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    }
    this.allSubscription();
    this.setOpportunity(this.auth.getAllOpportunity());
  }
  allSubscription() {
    this.opportunitySubscription = this.auth.newOpportunity.subscribe(
      (value) => {
        if (value) {
          // console.log('coming in side bar');
          this.setOpportunity(this.auth.getAllOpportunity());
        }
      }
    );
    this.sideBarSubscription = this.userService.toggleSideBar.subscribe(
      (value) => {
        if (value) {
          this.ToggleSubnav(value);
        }
      }
    );
  }
  ngOnDestroy() {
    this.opportunitySubscription.unsubscribe();
    this.sideBarSubscription.unsubscribe();
  }

  showHideData(i: number) {
    this.debtstageActive[i].showData = !this.debtstageActive[i].showData;
    // this.showData = !this.showData;
  }
  gotoCompletedPage() {
    this.ToggleSubnav('application');
    // if (this.router.url !== '/completed') {
    //   this.auth.setBackUrl(this.router.url);
    //   // console.log(this.router.url);
    // }
    if (this.auth.getCurrentUrl() !== '/completed') {
      this.auth.setBackUrl(this.auth.getCurrentUrl());
      // console.log(this.auth.getCurrentUrl(), "side-bar");
    }
    // this.router.navigate(['/completed']);
    this.auth.gotoUrl('/completed');
  }
  pathToSubnav(route: string) {
    // if (this.router.url !== route) {
    //   this.auth.setBackUrl(this.router.url);
    //   // console.log(this.router.url);
    // }
    if (this.auth.getCurrentUrl() !== route) {
      this.auth.setBackUrl(this.auth.getCurrentUrl());
    }

    this.goto(route);
  }
  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  setOpportunity(response) {
    // console.log('opportunity in side bar');
    // console.log(response);
    // // // this.completedApplication = [];
    this.openApplication = [];
    this.debtstageActive = [];
    response?.forEach((element) => {
      if (element.tlx_leadfor == 2) {
        // debt
        const opprtunityName =
          this.auth.opportunityType[element.tlx_debtneedstransactiontype];
        const activeStage = opportunityStage[`${element._activestageid_value}`];
        const data = {
          name: opprtunityName,
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              name: opprtunityName,
              showData: false,
              currentStage: element._activestageid_value,
              oppID: element.opportunityid,
              leadFor: element.tlx_leadfor,
              a: 'active',
              b:
                opportunityStage['ece3b3ec-e98a-4d95-8ce0-eff28d771b26'] <
                activeStage
                  ? 'active'
                  : '',
              c:
                opportunityStage['2d8c0501-6d5d-4f7e-a0c0-e9afe7c52164'] <
                activeStage
                  ? 'active'
                  : '',
              d:
                opportunityStage['2eda2878-affb-4fb3-ae3a-7d86a737a786'] <
                activeStage
                  ? 'active'
                  : '',
              e:
                opportunityStage['ba486328-0485-4273-b4ab-9a9faaa22423'] <
                activeStage
                  ? 'active'
                  : '',
              f:
                opportunityStage['f041dfe1-8e90-430c-9eb8-85ced7da8386'] <
                activeStage
                  ? 'active'
                  : '',
              g:
                opportunityStage['9ffd96ef-b806-4871-bf37-1a77a7edafc0'] <
                activeStage
                  ? 'active'
                  : '',
              h:
                opportunityStage['4cbe1585-4102-4ea1-bf17-a9e5328020d5'] <
                activeStage
                  ? 'active'
                  : '',
              i:
                opportunityStage['5da0f5ec-d070-48cf-946e-b4977631459a'] <
                activeStage
                  ? 'active'
                  : '',
              j:
                opportunityStage['16a09f15-0fef-4315-853b-83d47be3b241'] <=
                activeStage
                  ? 'active'
                  : '',
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      } else if (element.tlx_leadfor == 1) {
        // super
        const opprtunityName = element.name.split(' - ');
        const activeStage =
          superannuationOpportunityStage[`${element._activestageid_value}`];
        const data = {
          name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
              showData: false,
              currentStage: element._activestageid_value,
              oppID: element.opportunityid,
              leadFor: element.tlx_leadfor,

              a: 'active',
              b:
                superannuationOpportunityStage[
                  'a11f4588-28ec-8a7a-86f4-1d06dd4200cb'
                ] < activeStage
                  ? 'active'
                  : '',
              c:
                superannuationOpportunityStage[
                  '2ee1ba75-0b75-40c9-9a75-9106f4182f16'
                ] < activeStage
                  ? 'active'
                  : '',
              d:
                superannuationOpportunityStage[
                  'bf20f70a-8f44-4ef6-8e28-2de5fe2921c9'
                ] < activeStage
                  ? 'active'
                  : '',
              e:
                superannuationOpportunityStage[
                  'df4ce430-ccee-4a24-b922-da984b27adb9'
                ] < activeStage
                  ? 'active'
                  : '',

              f:
                superannuationOpportunityStage[
                  'b43ca487-1cca-40a5-8fbd-de322210386f'
                ] < activeStage
                  ? 'active'
                  : '',
              g:
                superannuationOpportunityStage[
                  '25e0e995-b9bd-4269-a68d-87df4a17b455'
                ] < activeStage
                  ? 'active'
                  : '',
              h:
                superannuationOpportunityStage[
                  '49e1509f-5970-42bd-85ae-0763915eae08'
                ] < activeStage
                  ? 'active'
                  : '',
              i:
                superannuationOpportunityStage[
                  'b50c99a7-a462-4b92-b960-b3a28f3de9a8'
                ] < activeStage
                  ? 'active'
                  : '',
              j:
                superannuationOpportunityStage[
                  '86a29103-435a-4d13-bfcf-7509cdedd7d7'
                ] <= activeStage
                  ? 'active'
                  : '',
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      } else if (element.tlx_leadfor == 9) {
        // managed investment
        const opprtunityName = element.name.split(' - ');
        const activeStage =
          managedInvestmentOpportunityStage[`${element._activestageid_value}`];
        const data = {
          name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
              showData: false,
              currentStage: element._activestageid_value,
              oppID: element.opportunityid,
              leadFor: element.tlx_leadfor,

              a: 'active',
              b:
                managedInvestmentOpportunityStage[
                  '7a2e74cf-784e-4a40-a6d4-52a78cfaddb1'
                ] < activeStage
                  ? 'active'
                  : '',
              c:
                managedInvestmentOpportunityStage[
                  '56b2b8c3-810b-4538-b3da-dcabd8b82a27'
                ] < activeStage
                  ? 'active'
                  : '',
              d:
                managedInvestmentOpportunityStage[
                  '245e5731-0211-428d-aaf0-96bb04702f7d'
                ] < activeStage
                  ? 'active'
                  : '',
              e:
                managedInvestmentOpportunityStage[
                  'bf12435e-14a5-49b1-94ad-1587b1f50f66'
                ] < activeStage
                  ? 'active'
                  : '',

              f:
                managedInvestmentOpportunityStage[
                  'ad8aa40b-c284-4eb7-a0e4-644035d7cd6a'
                ] < activeStage
                  ? 'active'
                  : '',
              g:
                managedInvestmentOpportunityStage[
                  '5ec99075-3775-4a62-9984-4a9c2f64cc9c'
                ] < activeStage
                  ? 'active'
                  : '',
              h:
                managedInvestmentOpportunityStage[
                  '8f49837e-20bd-4909-a1bc-f7f55c0f0bb2'
                ] < activeStage
                  ? 'active'
                  : '',
              i:
                managedInvestmentOpportunityStage[
                  'a6f4e59d-8c3d-4b40-bace-b93e1ebed4a2'
                ] < activeStage
                  ? 'active'
                  : '',
              j:
                managedInvestmentOpportunityStage[
                  '18101044-3c51-45f5-8b2b-4bc8405047c8'
                ] <= activeStage
                  ? 'active'
                  : '',
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      } else if (element.tlx_leadfor == 4) {
        // general insurance
        const opprtunityName = element.name.split(' - ');
        const activeStage =
          generalInsuranceOpportunityStage[`${element._activestageid_value}`];
        const data = {
          name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
              showData: false,
              currentStage: element._activestageid_value,
              oppID: element.opportunityid,
              leadFor: element.tlx_leadfor,

              a: 'active',
              b:
                generalInsuranceOpportunityStage[
                  '3d2d49c7-17f7-4e61-be92-7aec9d824fe9'
                ] < activeStage
                  ? 'active'
                  : '',
              c:
                generalInsuranceOpportunityStage[
                  '1e95aa1f-ce10-4a49-869f-73a17d4291cd'
                ] < activeStage
                  ? 'active'
                  : '',
              d:
                generalInsuranceOpportunityStage[
                  'daa80418-f805-49d1-a5ed-24d6b515529c'
                ] < activeStage
                  ? 'active'
                  : '',
              e:
                generalInsuranceOpportunityStage[
                  '7297956a-c73c-4971-ae62-e32114e29182'
                ] < activeStage
                  ? 'active'
                  : '',

              f:
                generalInsuranceOpportunityStage[
                  '06ddfd5e-8e72-47f5-b507-51534d4b62b3'
                ] < activeStage
                  ? 'active'
                  : '',
              g:
                generalInsuranceOpportunityStage[
                  '81c266c2-9e8b-4dba-9e1f-93b7b92ef672'
                ] < activeStage
                  ? 'active'
                  : '',
              // h:
              // generalInsuranceOpportunityStage[
              //     '8f49837e-20bd-4909-a1bc-f7f55c0f0bb2'
              //   ] < activeStage
              //     ? 'active'
              //     : '',
              // i:
              // generalInsuranceOpportunityStage[
              //     'a6f4e59d-8c3d-4b40-bace-b93e1ebed4a2'
              //   ] < activeStage
              //     ? 'active'
              //     : '',
              // j:
              // generalInsuranceOpportunityStage[
              //     '18101044-3c51-45f5-8b2b-4bc8405047c8'
              //   ] <= activeStage
              //     ? 'active'
              //     : '',
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      } else if (element.tlx_leadfor == 5) {
        // health insurance
        const opprtunityName = element.name.split(' - ');
        const activeStage =
          healthInsuranceOpportunityStage[`${element._activestageid_value}`];
        const data = {
          name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
              showData: false,
              currentStage: element._activestageid_value,
              oppID: element.opportunityid,
              leadFor: element.tlx_leadfor,

              a: 'active',
              b:
                healthInsuranceOpportunityStage[
                  'dd7d0688-38bc-484f-b3b6-00d974c00b3d'
                ] < activeStage
                  ? 'active'
                  : '',
              c:
                healthInsuranceOpportunityStage[
                  'a7e8150f-e667-4e32-a250-9f0e2aa4f1e9'
                ] < activeStage
                  ? 'active'
                  : '',
              d:
                healthInsuranceOpportunityStage[
                  '7279b36d-eb5b-42d8-a413-00b20233209b'
                ] < activeStage
                  ? 'active'
                  : '',
              e:
                healthInsuranceOpportunityStage[
                  '59b5f987-c91a-4f54-9171-7c1084a7f1cd'
                ] < activeStage
                  ? 'active'
                  : '',

              f:
                healthInsuranceOpportunityStage[
                  '95c0ac62-c756-489a-a5ba-fd80097b3895'
                ] < activeStage
                  ? 'active'
                  : '',
              g:
                healthInsuranceOpportunityStage[
                  'cb3d67b2-d699-47bf-945d-4828c8be0e3e'
                ] < activeStage
                  ? 'active'
                  : '',
              // h:
              // generalInsuranceOpportunityStage[
              //     '8f49837e-20bd-4909-a1bc-f7f55c0f0bb2'
              //   ] < activeStage
              //     ? 'active'
              //     : '',
              // i:
              // generalInsuranceOpportunityStage[
              //     'a6f4e59d-8c3d-4b40-bace-b93e1ebed4a2'
              //   ] < activeStage
              //     ? 'active'
              //     : '',
              // j:
              // generalInsuranceOpportunityStage[
              //     '18101044-3c51-45f5-8b2b-4bc8405047c8'
              //   ] <= activeStage
              //     ? 'active'
              //     : '',
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      } else if (element.tlx_leadfor == 6) {
        // Estate planning
        const opprtunityName = element.name.split(' - ');
        const activeStage =
          estatePlanningOpportunityStage[`${element._activestageid_value}`];
        const data = {
          name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
              showData: false,
              currentStage: element._activestageid_value,
              oppID: element.opportunityid,
              leadFor: element.tlx_leadfor,

              a: 'active',
              b:
                estatePlanningOpportunityStage[
                  '860c244b-9214-48f4-942e-267926726fdb'
                ] < activeStage
                  ? 'active'
                  : '',
              c:
                estatePlanningOpportunityStage[
                  'd408967b-797a-48f2-9200-4233ff61d00d'
                ] < activeStage
                  ? 'active'
                  : '',
              d:
                estatePlanningOpportunityStage[
                  'c8d01d17-01f1-4e6e-9db9-545ffed1f890'
                ] < activeStage
                  ? 'active'
                  : '',
              e:
                estatePlanningOpportunityStage[
                  '143a267d-bfe0-48bb-9d5c-109c2f6c17b1'
                ] < activeStage
                  ? 'active'
                  : '',

              f:
                estatePlanningOpportunityStage[
                  'b4878a2f-d020-4b70-82a6-25b3fecc6f00'
                ] < activeStage
                  ? 'active'
                  : '',
              g:
                estatePlanningOpportunityStage[
                  'dd752a5e-b234-4241-912f-a8937dab14ee'
                ] < activeStage
                  ? 'active'
                  : '',
              // h:
              // generalInsuranceOpportunityStage[
              //     '8f49837e-20bd-4909-a1bc-f7f55c0f0bb2'
              //   ] < activeStage
              //     ? 'active'
              //     : '',
              // i:
              // generalInsuranceOpportunityStage[
              //     'a6f4e59d-8c3d-4b40-bace-b93e1ebed4a2'
              //   ] < activeStage
              //     ? 'active'
              //     : '',
              // j:
              // generalInsuranceOpportunityStage[
              //     '18101044-3c51-45f5-8b2b-4bc8405047c8'
              //   ] <= activeStage
              //     ? 'active'
              //     : '',
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      } else if (element.tlx_leadfor == 7) {
        // finnancial planning
        const opprtunityName = element.name.split(' - ');
        const activeStage =
          financialPlanningOpportunityStage[`${element._activestageid_value}`];
        const data = {
          name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
              showData: false,
              currentStage: element._activestageid_value,
              oppID: element.opportunityid,
              leadFor: element.tlx_leadfor,

              a: 'active',
              b:
                financialPlanningOpportunityStage[
                  '97f16148-4f74-4ead-887d-c3546a6e8cf9'
                ] < activeStage
                  ? 'active'
                  : '',
              c:
                financialPlanningOpportunityStage[
                  '05de9ac0-c6cb-458d-8ce9-7b15f27f20d3'
                ] < activeStage
                  ? 'active'
                  : '',
              d:
                financialPlanningOpportunityStage[
                  '47153fb5-92e1-4256-97c9-19e17695e210'
                ] < activeStage
                  ? 'active'
                  : '',
              e:
                financialPlanningOpportunityStage[
                  '761cd62f-cb3d-462c-86e9-d82be5aab55d'
                ] < activeStage
                  ? 'active'
                  : '',

              f:
                financialPlanningOpportunityStage[
                  '274a2637-1ce8-414e-a870-1d581b726c89'
                ] < activeStage
                  ? 'active'
                  : '',
              g:
                financialPlanningOpportunityStage[
                  '2533fab7-2fb0-4855-8a10-d55ece667f9b'
                ] < activeStage
                  ? 'active'
                  : '',
              h:
                financialPlanningOpportunityStage[
                  '2d159854-8941-45c4-87df-9cfe05a27bee'
                ] < activeStage
                  ? 'active'
                  : '',
              i:
                financialPlanningOpportunityStage[
                  'ed46d589-c988-4fff-86da-a7cee673f375'
                ] < activeStage
                  ? 'active'
                  : '',
              j:
                financialPlanningOpportunityStage[
                  'ecd6e91a-2ed8-4222-b45c-b41ca49685b6'
                ] <= activeStage
                  ? 'active'
                  : '',
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      } else if (element.tlx_leadfor == 3) {
        //  console.log(element);
        const opprtunityName = element.name.split(' - ');
        //  const activeStage = opportunityStage[`${element._activestageid_value}`];

        const data = {
          name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
          // stage: element._activestageid_value_Formatted,
          children: [
            {
              showData: false,
              name: opprtunityName[1] ? opprtunityName[1] : opprtunityName[0],
              leadFor: element.tlx_leadfor,
              // currentStage: element._activestageid_value,
              oppID: element.opportunityid,
            },
          ],
        };
        this.debtstageActive.push(data.children[0]);
        this.openApplication.push(data);
      }
    });
  }
  showComingSoon() {
    this.auth.showSnackBarMsg('Coming Soon!');
  }

  disableOpportunity(oppID: string, leadFor: number) {
    console.log(oppID);
    this.ToggleSubnav('application');
    const dialogRef = this.dialog.open(WithdrawOpportunityPopupComponent, {
      width: '720px',
      position: { right: '0', bottom: '0' },
      data: { type: 'add', data: oppID, leadFor },
    });
  }

  ToggleSubnav(element) {
    if (element == 'dashboard') {
      this.auth.showSnackBarMsg('Coming Soon!');
    }
    if (this.activeNav !== element) {
      this.activeNav = element;
    } else {
      this.activeNav = '';
    }
  }

  closeSubnav() {
    this.activeNav = '';
  }
  goto(route: string) {
    this.redirectToURL(route);
    this.closeSubnav();
  }

  redirectToURL(url = '') {
    // this.router.navigate([url]);
    // window.scroll(0, 0);
    this.auth.gotoUrl(url);
  }

  gotoDebtCurrentStage(stage: string) {
    // console.log(stage);
    const url = this.auth.getDebtCurrentUrl(stage);
    // console.log('url');
    // console.log(url);
    this.closeSubnav();
    this.redirectToURL(url);
  }
  gotoSuperannuationCurrentStage(stage: string) {
    const url = this.auth.getSuperCurrentUrl(stage);
    this.closeSubnav();
    this.redirectToURL(url);
  }
  gotomanagedinvestmentCurrentStage(stage: string) {
    const url = this.auth.getmanagedInvestmentCurrentUrl(stage);
    this.closeSubnav();
    this.redirectToURL(url);
  }
  gotoGeneralInsuranceCurrentStage(stage: string) {
    const url = this.auth.getGeneralInsuranceCurrentUrl(stage);
    this.closeSubnav();
    this.redirectToURL(url);
  }
  gotoHealthInsuranceCurrentStage(stage: string) {
    const url = this.auth.getHealthInsuranceCurrentUrl(stage);
    this.closeSubnav();
    this.redirectToURL(url);
  }
  gotoEstatePlanningCurrentStage(stage: string) {
    const url = this.auth.getEstatePlanningCurrentUrl(stage);
    this.closeSubnav();
    this.redirectToURL(url);
  }

  gotoFinancialPlanningCurrentStage(stage: string) {
    const url = this.auth.getFinancialPlanningCurrentUrl(stage);
    this.closeSubnav();
    this.redirectToURL(url);
  }
}
